export const SET_2F_AUTHENTICATION = 'SET_2F_AUTHENTICATION'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_IS_IMPERSONATING = 'SET_IS_IMPERSONATING'
export const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA'
